module.exports = __webpack_public_path__ + "img/cinta.89f1f945.png";